import styled, { css } from "styled-components";
import { FlexContainers, Paragraph2 } from "../index";
import { colors } from "../../consts";

const SlashBefore = css`
  &:after {
    content: "/";
    position: absolute;
    left: -16px;
    color: ${colors.RAISIN_10};
    width: 8px;
  }
`;

const SlashAfter = css`
  &:after {
    content: "/";
    position: absolute;
    right: -16px;
    color: ${colors.RAISIN_10};
    width: 8px;
  }
`;

export const BreadcrumbsContainer = styled(FlexContainers.FlexRowStart)`
  gap: 24px;

  a[disabled] {
    pointer-events: none;
  }
`;

export const BreadcrumbContainer = styled(Paragraph2)`
  position: relative;
  color: ${colors.RAISIN_70} !important;
  line-height: 150% !important;
  font-size: 16px !important;
  width: max-content;

  ${(props) => props?.slashBefore && SlashBefore}
  ${(props) => props?.slashAfter && SlashAfter}
`;
